<template>
	<section class="EducationalFormFilterWrapper"
	         :class="{'is-collapsed': collapsed}"
	>
		<header class="RefineSectionHeading" @click="toggleFilter()">
			<i class="lnr-apartment FilterIcon"></i>
			<div class="Title">
				Educational Form
			</div>
			<span v-if="filterHintCount > 0" class="Badge">
				{{ filterHintCount }}
			</span>
			<i class="ToggleIcon" :class="[collapsed ? 'lnr-chevron-down' : 'lnr-chevron-up']"></i>
		</header>

		<ul class="RefineContentOptionsList">
			<li v-for="item in filterOptions">
				<Checkbox
					:filterKey="key"
					:optionName="item.optionName"
					:optionValue="item.optionValue"
				/>
			</li>
		</ul>
	</section>
</template>

<script lang="ts" src="./EducationalFormFilter.ts"></script>
